export const PROXY_URL = 'https://melannett.ru';
export const SITE_NAME = 'Melannett';
export const CP_PUBLIK_KEY_RU = 'pk_97756047bd8fd326c135057475e39';
export const CP_PUBLIK_KEY_SNG = 'pk_eff93a454e9b3e5e5acb1eba4b3e8';
export const YM_KEY = '50557465';
export const TRY_SUBSON_5_DAYS_POPUP_TIMER = 5000;
export const TRY_SUBSON_5_DAYS_POPUP_TIMER_20 = 15000;
export const COUNT_COURSES_PER_PAGE = 6;
